import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import { isNil } from 'lodash'

import MechanicalWorkshopRepository from '@/shared/http/repositories/configuration/mechanicalworkshop'
import MechanicalWorkshopModel from '@/shared/models/configuration/mechanicalworkshopmodel'
import MechanicalWorkshopForms from './mechanicalworkshop-form'
import WorkshopBudgetRepository from '@/shared/http/repositories/configuration/workshopbudget'
import WorkshopBudgetModel from '@/shared/models/configuration/workshopbudgetmodel'
import WorkshopBudgetForms from './workshopbudget-form'

import StateRepository from '@/shared/http/repositories/geo/state'
import CityRepository from '@/shared/http/repositories/geo/city'

import InsuranceMixin from '@/store/module/insurance/mixin.js'
import { JWTService } from '@/shared/services/jwt'

export default {
  name: 'MechanicalWorkshop',
  mixins: [
    ActionsForm,
    InsuranceMixin
  ],
  data () {
    return {
      data: MechanicalWorkshopModel,
      form: MechanicalWorkshopForms,
      dataBudget: WorkshopBudgetModel,
      formBudget: WorkshopBudgetForms,
      objListBudget: [],
      workshopid: 0,
      companyID: 0,
      status: '',
      accountUserNameUpdate: '',
      dateUpdate: '',
      AccountName: decodeURIComponent(escape(JWTService.GetTokenPayload().Name)),
      type: 0,
      budgetID: 0,
      showModal: false,
      mechanicalworkshop: null
    }
  },
  mounted () {
    this.onLoadAllState()
    this.getAllInsuranceByArea(process.env.AreaAutos)
    this.objListBudget = []
    this.workshopid = 0
    this.companyID = 0
    this.status = ''
    this.accountUserNameUpdate = ''
    this.dateUpdate = ''
    this.type = 0
    this.budgetID = 0

    const hasData = !isNil(this.mechanicalworkshop ? this.mechanicalworkshop.id : null)

    if (hasData) {
      this.onEdit(this.mechanicalworkshop)
    }

    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      const hasData = !isNil(this.mechanicalworkshop ? this.mechanicalworkshop.id : null)

      if (hasData) {
        return this.onEdit(this.mechanicalworkshop)
      }
    })
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    },
    getAllInsurer: function () {
      var result = []
      if ((this.insurances) && (this.insurances.count) > 0) {
        var data = this.insurances.data
        for (var i in data) {
          if (data[i].status) {
            result.push({ 'label': data[i].name, 'value': data[i].id })
          }
        }
        this.form.insurance.options = result
      }
      return result
    }
  },
  methods: {
    onLoad () {
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.objListBudget = []
      this.workshopid = null
      this.companyID = null
      this.status = ''
      this.accountUserNameUpdate = ''
      this.dateUpdate = ''
      this.type = 0
      this.budgetID = 0
      this.mechanicalworkshop = null
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        Tools.SetValueInForm(this.form, this.data, obj)
        // --> Set manual

        if (obj.city && obj.city.stateID) {
          this.form.stateID.value = obj.city.stateID
          this.onChangeState()
        }

        var self = this
        this.companyID = obj.companyID
        this.workshopid = obj.id
        this.dateUpdate = obj.dateUpdate
        this.accountUserNameUpdate = obj.accountUserNameUpdate
        this.status = obj.status
        this.onLoadBudget()
        setTimeout(function (e) {
          self.form.cityID.value = obj.cityID
        }, 1500)

        loading.pop()
      }
    },
    onEditById (ID) {
      this.workshopid = null
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        MechanicalWorkshopRepository.GetById(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onCreate () {
      loading.push()
      MechanicalWorkshopRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
          this.onSaveBudget(response.data)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      MechanicalWorkshopRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, false, true)

          if (response.data.code === 0 && response.data.data) {
            this.$emit('Edit', response.data.data.id)
          }

          this.onSaveBudget(response.data)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllState () {
      loading.push()
      StateRepository.GetAll()
        .then((response) => {
          this.form.stateID.options = this.onResultDropdown(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllCity (id) {
      this.form.cityID.options = []
      if (id) {
        loading.push()
        CityRepository.GetAllByStateID(id)
          .then((response) => {
            this.form.cityID.options = this.onResultDropdown(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.form.stateID.value)
      }, 500)
    },
    onLoadBudget () {
      if (this.workshopid) {
        console.log(this.workshopid)
        WorkshopBudgetRepository.GetAllPaging(this.workshopid, this.$refs.tableGridBudget.pagingLimit, this.$refs.tableGridBudget.pagingIndex)
          .then((response) => {
            this.onStartTotalGrid(this.$refs.tableGridBudget, response.data.data.length)
            this.objListBudget = []
            this.objListBudget = response.data.data
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onCreateBudget () {
      if (this.formBudget.nameBudget.value !== '' && this.formBudget.cellNumberBudget.value !== '') {
        this.onStartTotalGrid(this.$refs.tableGridBudget, 1)
        this.objListBudget.push({
          companyID: this.companyID,
          mechanicalWorkshopID: this.workshopid,
          nameBudget: this.formBudget.nameBudget.value,
          emailBudget: this.formBudget.emailBudget.value,
          cellNumberBudget: this.formBudget.cellNumberBudget.value,
          dateUpdate: this.dateUpdate,
          accountUserNameUpdate: this.AccountName,
          status: this.status
        })
      }
      this.formBudget.nameBudget.value = ''
      this.formBudget.emailBudget.value = ''
      this.formBudget.cellNumberBudget.value = ''
    },
    onSaveBudget (data) {
      WorkshopBudgetRepository.Create(this.objListBudget)
        .then((response) => {
          this.onStartTotalGrid(this.$refs.tableGridBudget, 0)
          this.objListBudget = []
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDeleteBudget (obj) {
      WorkshopBudgetRepository.Delete(obj.id)
        .then((response) => {
          this.onLoadBudget()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    closeModal () {
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mechanicalworkshop/mechanicalworkshop.js